import { useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const resolveSrc = (u) => (u && u.startsWith("/") ? `${BACKEND}${u}` : u);

export default function ImageField({ value, onChange, testid }) {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const r = await api.post("/admin/upload", fd);
      onChange(r.data.url);
      toast.success("Afbeelding geüpload");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload mislukt");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="mt-1.5 space-y-2">
      <div className="flex items-center gap-3">
        {value ? (
          <img src={resolveSrc(value)} alt="voorbeeld" className="h-16 w-16 rounded-md object-cover border border-[#E2E8F0]" data-testid={`${testid}-preview`} />
        ) : (
          <div className="h-16 w-16 rounded-md border border-dashed border-[#E2E8F0] grid place-items-center text-[#0B0B0C]/30 text-[11px]">Geen</div>
        )}
        <label className="inline-flex items-center gap-2 px-3 py-2 rounded-md border border-[#E2E8F0] text-sm cursor-pointer hover:border-[#0A3087] hover:text-[#0A3087] transition-colors" data-testid={`${testid}-upload`}>
          {uploading ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} />}
          {uploading ? "Uploaden..." : "Upload"}
          <input type="file" accept="image/*" onChange={handleFile} className="hidden" disabled={uploading} />
        </label>
      </div>
      <Input value={value ?? ""} onChange={(e) => onChange(e.target.value)} placeholder="of plak een afbeelding-URL" className="text-xs" data-testid={testid} />
    </div>
  );
}
